var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExternalLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9375 11.4545C16.4898 11.4545 16.9375 11.9023 16.9375 12.4545V13.7273C16.9375 14.3625 16.6591 14.9499 16.2001 15.3672C15.7443 15.7815 15.1449 16 14.5375 16H3.3375C2.73011 16 2.13067 15.7815 1.67488 15.3672C1.21591 14.9499 0.9375 14.3625 0.9375 13.7273V2.27273C0.9375 1.63754 1.21591 1.05008 1.67488 0.632833C2.13067 0.218473 2.73011 0 3.3375 0L6.4375 0C6.98979 0 7.4375 0.447715 7.4375 1C7.4375 1.55228 6.98979 2 6.4375 2H3.3375C3.20228 2 3.08953 2.04971 3.02022 2.11271C2.95409 2.17284 2.9375 2.23282 2.9375 2.27273V13.7273C2.9375 13.7672 2.95409 13.8272 3.02022 13.8873C3.08953 13.9503 3.20228 14 3.3375 14H14.5375C14.6727 14 14.7855 13.9503 14.8548 13.8873C14.9209 13.8272 14.9375 13.7672 14.9375 13.7273V12.4545C14.9375 11.9023 15.3852 11.4545 15.9375 11.4545Z",
    fill: "#323E49"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4375 1H15.9375V5",
    stroke: "#323E49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9375 1L5.9375 11",
    stroke: "#323E49",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external_link.06a7f3ea.svg";
export { ForwardRef as ReactComponent };